import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-md-flex d-none ga-4 mx-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_navigation_drawer, {
      modelValue: _ctx.drawer,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.drawer) = $event)),
      color: "",
      "disable-resize-watcher": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_list, { nav: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_list_item, {
              ripple: "",
              onClick: _ctx.onMainViewClick,
              title: "Főoldal"
            }, {
              prepend: _withCtx(() => [
                _createVNode(_component_v_icon, { icon: "mdi-home" })
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_v_list_item, {
              ripple: "",
              onClick: _ctx.onAboutClick,
              title: "Rólunk"
            }, {
              prepend: _withCtx(() => [
                _createVNode(_component_v_icon, { icon: "mdi-information" })
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_v_list_item, {
              ripple: "",
              onClick: _ctx.onGalleryClick,
              title: "Galéria"
            }, {
              prepend: _withCtx(() => [
                _createVNode(_component_v_icon, { icon: "mdi-image" })
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_v_list_item, {
              ripple: "",
              onClick: _ctx.onConnectionClick,
              title: "Kapcsolat"
            }, {
              prepend: _withCtx(() => [
                _createVNode(_component_v_icon, { icon: "mdi-phone" })
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_app_bar, {
      flat: "",
      elevation: _ctx.elevation,
      color: _ctx.appBarColor
    }, {
      default: _withCtx(() => [
        (_ctx.$vuetify.display.smAndDown)
          ? (_openBlock(), _createBlock(_component_v_app_bar_nav_icon, {
              key: 0,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.drawer = !_ctx.drawer))
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_v_btn, {
            style: _normalizeStyle(_ctx.appBarTextColor),
            onClick: _ctx.onMainViewClick
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode("Főoldal")
            ])),
            _: 1
          }, 8, ["style", "onClick"]),
          _createVNode(_component_v_btn, {
            style: _normalizeStyle(_ctx.appBarTextColor),
            onClick: _ctx.onAboutClick
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode("Rólunk")
            ])),
            _: 1
          }, 8, ["style", "onClick"]),
          _createVNode(_component_v_btn, {
            style: _normalizeStyle(_ctx.appBarTextColor),
            onClick: _ctx.onGalleryClick
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("Galéria")
            ])),
            _: 1
          }, 8, ["style", "onClick"]),
          _createVNode(_component_v_btn, {
            style: _normalizeStyle(_ctx.appBarTextColor),
            onClick: _ctx.onConnectionClick
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode("Kapcsolat")
            ])),
            _: 1
          }, 8, ["style", "onClick"])
        ])
      ]),
      _: 1
    }, 8, ["elevation", "color"])
  ], 64))
}